import {AppState} from "redux/reducers/AppReducer"
import {store} from "store"

export const useApp = (): AppState => {
  return store.getState().app
}

export const useUser = () => {
  return store.getState().user
}

export const useIndicators = () => {
  return store.getState().indicators
}

export const useAuctionSettings = () => {
  return store.getState().app.settings
}

export const useCodes = () => {
  return store.getState().app.codes
}